import { render, staticRenderFns } from "./NotStartedIcon.vue?vue&type=template&id=6f64d8d0&scoped=true"
import script from "./NotStartedIcon.vue?vue&type=script&lang=js"
export * from "./NotStartedIcon.vue?vue&type=script&lang=js"
import style0 from "./NotStartedIcon.vue?vue&type=style&index=0&id=6f64d8d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f64d8d0",
  null
  
)

export default component.exports